import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

export interface RoleState {
    roles: any[]
}

const initialState: RoleState = {
    roles: []
}

export const rolesSlice = createSlice({
    name: 'roles',
    initialState,
    reducers: {
        getRoles: (state) => {
            void state;
        },
        setRoles: (state, action: PayloadAction<any[]>) => {
            state.roles = action.payload
        }
    }
})

export const {
    getRoles,
    setRoles
} = rolesSlice.actions

export default rolesSlice.reducer
